import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Badge,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  FaHeadphones,
  FaPhotoVideo,
  FaWallet,
  FaProjectDiagram,
  FaCheckSquare,
  FaTasks,
  FaSitemap,
  FaGift,
  FaGraduationCap,
  FaMicrophone,
  FaVideo,
  FaExchangeAlt,
} from "react-icons/fa";
import { HOME_UNIQUE_FEATURES } from "../../../content/productGuide";
import { TiltCard } from "../../common/TiltCard";
import { usePublicGlassSurface } from "../../common/publicVisual";

const ICONS = {
  "Screen AI": FaHeadphones,
  "Media AI": FaPhotoVideo,
  "Audio AI": FaMicrophone,
  "Video AI": FaVideo,
  "Transfer AI": FaExchangeAlt,
  "Portfolio AI": FaWallet,
  "Project AI": FaProjectDiagram,
  "Todos AI": FaCheckSquare,
  "Daily Chore AI": FaTasks,
  "Exam AI": FaGraduationCap,
  "3D org tree": FaSitemap,
  "Free core workspace": FaGift,
};

export default function UniqueFeatures() {
  const glass = usePublicGlassSurface();
  const muted = useColorModeValue("gray.600", "gray.400");
  const { badge, heading, sub, items } = HOME_UNIQUE_FEATURES;

  return (
    <Box
      as="section"
      id="unique"
      py={{ base: 12, md: 16 }}
      bg={useColorModeValue("gray.50", "gray.900")}
    >
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <VStack spacing={3} textAlign="center" mb={{ base: 8, md: 10 }} maxW="3xl" mx="auto">
          <Badge colorScheme="purple" borderRadius="full" px={3} py={1} fontSize="xs">
            {badge}
          </Badge>
          <Heading as="h2" size="xl" fontWeight="extrabold">
            {heading}
          </Heading>
          <Text fontSize="md" color={muted} lineHeight="tall">
            {sub}
          </Text>
        </VStack>

        <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={{ base: 4, md: 5 }}>
          {items.map((item) => {
            const IconCmp = ICONS[item.title] || FaGift;
            const accent = item.accent || "teal";
            return (
              <TiltCard
                key={item.title}
                tilt={6}
                borderWidth="1px"
                borderRadius="xl"
                p={5}
                h="full"
                {...glass}
              >
                <Icon
                  as={IconCmp}
                  boxSize={6}
                  color={`${accent}.500`}
                  mb={3}
                  sx={{ _dark: { color: `${accent}.300` } }}
                />
                <Heading as="h3" size="sm" fontWeight="bold" mb={2}>
                  {item.title}
                </Heading>
                <Text fontSize="sm" color={muted} lineHeight="tall">
                  {item.description}
                </Text>
              </TiltCard>
            );
          })}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
